/** Type d'une ligne de tournée (issue #3627) — miroir de TypeRepasTourneeEnum côté back. */
export enum TypeRepasTourneeEnum {
  PRESTATION = 'PRESTATION',
  PRODUIT_COMPLEMENTAIRE = 'PRODUIT_COMPLEMENTAIRE'
}

export const TYPE_REPAS_TOURNEE_LABELS: Record<TypeRepasTourneeEnum, string> = {
  [TypeRepasTourneeEnum.PRESTATION]:             'Prestation',
  [TypeRepasTourneeEnum.PRODUIT_COMPLEMENTAIRE]: 'Produit complémentaire',
};
